import React from 'react';
import { CommentNewSubmitButton } from '@udecode/plate-comments';
import { primaryButtonCss } from '@udecode/plate-ui-button';

export const PlateCommentNewSubmitButton = () => {
  return <CommentNewSubmitButton css={primaryButtonCss} />;
};
